export const ledgerTransfersTranslations = {
    de: {
        title: 'Eigene Kontoüberträge',
        subtitle: 'Bereits ausgeführte Bewegungen zwischen eigenen Geldkonten erfassen und abstimmen.',
        notice: 'Diese Erfassung löst keine Überweisung aus. Abgang und Eingang erhalten ihre tatsächlichen Daten; Geld unterwegs bleibt auf dem Verrechnungskonto sichtbar.',
        new: 'Übertrag erfassen',
        save: 'Ausgeführten Übertrag speichern',
        from: 'Von Geldkonto',
        to: 'An Geldkonto',
        outgoingDate: 'Datum des Abgangs',
        incomingDate: 'Datum des Eingangs',
        export: 'CSV exportieren',
        incomingFeeAmount: 'Beim Eingang abgezogene Gebühr in Eingangswährung',
        outgoingAmount: 'Tatsächlicher Abgang inklusive Gebühren',
        incomingAmount: 'Tatsächlicher Eingang',
        feeAmount: 'Enthaltene Gebühr in Abgangswährung',
        outgoingCurrency: 'Abgangswährung',
        incomingCurrency: 'Eingangswährung',
        outgoingRate: 'Abgangskurs zur Buchhaltungswährung',
        incomingRate: 'Eingangskurs zur Buchhaltungswährung',
        received: 'Eingang auf dem Zielkonto bereits nachgewiesen',
        complete: 'Eingang erfassen',
        PENDING: 'Geld unterwegs',
        RECEIVED: 'Vollständig erfasst',
        REVERSED: 'Fehlerhafte Erfassung storniert',
        empty: 'Keine Kontoüberträge für diesen Filter vorhanden.',
        sourceHint: 'Bei gleicher Währung müssen Abgang abzüglich ausdrücklicher Gebühr und Eingang übereinstimmen. Kurse und Quelle werden festgehalten.',
        reverse: 'Fehlerhafte Erfassung stornieren',
        reverseHint: 'Korrigiert die Erfassung beider Geldbewegungen mit Gegenbuchungen. Einen tatsächlich zurückgeführten Betrag als neuen Übertrag erfassen.',
    },
    en: {
        title: 'Own account transfers',
        subtitle: 'Record and reconcile completed movements between your own money accounts.',
        notice: 'This does not initiate a bank transfer. Outgoing and incoming legs use their actual dates; money in transit stays visible in the clearing account.',
        new: 'Record transfer',
        save: 'Save completed transfer',
        from: 'From money account',
        to: 'To money account',
        outgoingDate: 'Outgoing cash date',
        incomingDate: 'Incoming cash date',
        export: 'Export CSV',
        incomingFeeAmount: 'Fee deducted on receipt in incoming currency',
        outgoingAmount: 'Actual outgoing amount including fees',
        incomingAmount: 'Actual incoming amount',
        feeAmount: 'Included fee in outgoing currency',
        outgoingCurrency: 'Outgoing currency',
        incomingCurrency: 'Incoming currency',
        outgoingRate: 'Outgoing rate to accounting currency',
        incomingRate: 'Incoming rate to accounting currency',
        received: 'Receipt on destination account already evidenced',
        complete: 'Record receipt',
        PENDING: 'Money in transit',
        RECEIVED: 'Fully recorded',
        REVERSED: 'Incorrect registration reversed',
        empty: 'No own transfers match this filter.',
        sourceHint: 'For the same currency, outgoing cash less the explicit fee must equal incoming cash. Rates and their source are retained.',
        reverse: 'Reverse incorrect registration',
        reverseHint: 'Corrects both registered cash legs with reversing entries. Record an actual return of money as a new transfer.',
    },
    tr: {
        title: 'Kendi hesapları arası aktarımlar',
        subtitle: 'Kendi para hesaplarınız arasında gerçekleşmiş hareketleri kaydedin ve mutabakatını yapın.',
        notice: 'Bu kayıt bankaya havale talimatı vermez. Çıkış ve giriş gerçek tarihleriyle kaydedilir; yoldaki para geçici hesapta görünür kalır.',
        new: 'Aktarım kaydet',
        save: 'Gerçekleşmiş aktarımı kaydet',
        from: 'Kaynak para hesabı',
        to: 'Hedef para hesabı',
        outgoingDate: 'Çıkış tarihi',
        incomingDate: 'Giriş tarihi',
        export: 'CSV dışa aktar',
        incomingFeeAmount: 'Giriş para biriminde girişte kesilen ücret',
        outgoingAmount: 'Ücretler dahil gerçek çıkış',
        incomingAmount: 'Gerçek giriş',
        feeAmount: 'Çıkış para biriminde dahil edilen ücret',
        outgoingCurrency: 'Çıkış para birimi',
        incomingCurrency: 'Giriş para birimi',
        outgoingRate: 'Çıkışın muhasebe para birimi kuru',
        incomingRate: 'Girişin muhasebe para birimi kuru',
        received: 'Hedef hesaba giriş zaten belgelenmiş',
        complete: 'Girişi kaydet',
        PENDING: 'Yoldaki para',
        RECEIVED: 'Tamamen kaydedildi',
        REVERSED: 'Hatalı kayıt ters çevrildi',
        empty: 'Bu filtreye uygun hesap aktarımı yok.',
        sourceHint: 'Para birimleri aynıysa çıkıştan açıkça belirtilen ücret düşüldüğünde giriş tutarına eşit olmalıdır. Kurlar ve kaynakları saklanır.',
        reverse: 'Hatalı kaydı ters çevir',
        reverseHint: 'İki kayıtlı para hareketini ters kayıtlarla düzeltir. Gerçek para iadesini yeni bir aktarım olarak kaydedin.',
    },
    fr: {
        title: 'Virements entre comptes propres',
        subtitle: 'Enregistrer et rapprocher les mouvements effectués entre vos propres comptes de trésorerie.',
        notice: 'Cette saisie ne déclenche aucun virement bancaire. Sortie et entrée portent leurs dates réelles ; les fonds en transit restent visibles au compte de liaison.',
        new: 'Enregistrer un virement',
        save: 'Enregistrer le virement effectué',
        from: 'Compte de départ',
        to: 'Compte destinataire',
        outgoingDate: 'Date de sortie',
        incomingDate: 'Date d’entrée',
        export: 'Exporter CSV',
        incomingFeeAmount: 'Frais déduits à l’arrivée en devise d’entrée',
        outgoingAmount: 'Sortie réelle, frais compris',
        incomingAmount: 'Entrée réelle',
        feeAmount: 'Frais inclus en devise de sortie',
        outgoingCurrency: 'Devise de sortie',
        incomingCurrency: 'Devise d’entrée',
        outgoingRate: 'Taux de sortie vers la devise comptable',
        incomingRate: 'Taux d’entrée vers la devise comptable',
        received: 'Entrée déjà justifiée sur le compte destinataire',
        complete: 'Enregistrer l’entrée',
        PENDING: 'Fonds en transit',
        RECEIVED: 'Entièrement enregistré',
        REVERSED: 'Saisie erronée contrepassée',
        empty: 'Aucun virement propre pour ce filtre.',
        sourceHint: 'Dans une même devise, la sortie diminuée des frais explicites doit égaler l’entrée. Les taux et leur source sont conservés.',
        reverse: 'Contrepasser une saisie erronée',
        reverseHint: 'Corrige les deux mouvements saisis par des contre-écritures. Un retour réel de fonds se saisit comme un nouveau virement.',
    },
    es: {
        title: 'Traspasos entre cuentas propias',
        subtitle: 'Registrar y conciliar movimientos realizados entre sus propias cuentas de tesorería.',
        notice: 'Este registro no inicia una transferencia bancaria. La salida y la entrada conservan sus fechas reales; el dinero en tránsito permanece visible en la cuenta puente.',
        new: 'Registrar traspaso',
        save: 'Guardar el traspaso realizado',
        from: 'Cuenta de origen',
        to: 'Cuenta de destino',
        outgoingDate: 'Fecha de salida',
        incomingDate: 'Fecha de entrada',
        export: 'Exportar CSV',
        incomingFeeAmount: 'Comisión descontada al recibir en la moneda de entrada',
        outgoingAmount: 'Salida real incluidas comisiones',
        incomingAmount: 'Entrada real',
        feeAmount: 'Comisión incluida en la moneda de salida',
        outgoingCurrency: 'Moneda de salida',
        incomingCurrency: 'Moneda de entrada',
        outgoingRate: 'Tipo de salida a la moneda contable',
        incomingRate: 'Tipo de entrada a la moneda contable',
        received: 'Entrada en la cuenta de destino ya justificada',
        complete: 'Registrar entrada',
        PENDING: 'Dinero en tránsito',
        RECEIVED: 'Registro completo',
        REVERSED: 'Registro incorrecto anulado',
        empty: 'No hay traspasos propios para este filtro.',
        sourceHint: 'En la misma moneda, la salida menos la comisión explícita debe coincidir con la entrada. Se conservan los tipos y su fuente.',
        reverse: 'Anular un registro incorrecto',
        reverseHint: 'Corrige ambos movimientos registrados mediante asientos inversos. Registre una devolución real de fondos como un nuevo traspaso.',
    },
};
//# sourceMappingURL=ledger-transfers.js.map